import React, { useEffect, useState } from 'react';
import Button from 'chameleon/ui-stack/ui/base/button';
import CheckBox from 'chameleon/ui-stack/ui/base/checkbox';

const LabelWithCheckbox = ({ name, isSelected, onSelect = () => {} }) => {
  const [isChecked, setIsChecked] = useState(isSelected);

  const handleClick = () => {
    setIsChecked((state) => {
      onSelect(!state);
      return !state;
    });
  };

  useEffect(() => {
    setIsChecked(isSelected);
  }, [isSelected]);

  return (
    <Button
      size="custom"
      className="py-2.8 px-4.2 text-left flex items-center max-w-full"
      isNaked
      isWrap={false}
      onClick={handleClick}
      accessibility={{
        'aria-label': isChecked ? `${name} is selected` : name,
      }}
    >
      <div className="w-8">
        <CheckBox
          tabIndex={-1}
          width={24}
          height={24}
          checked={isChecked}
          className="float-left"
          background="gray"
        />
      </div>
      <span className="text-14 ml-4 leading-none break-words w-10/12">
        {name}
      </span>
    </Button>
  );
};

export default LabelWithCheckbox;
